import React, {useEffect, useState} from "react";
import {Col, Form, InputGroup} from "react-bootstrap";

const DatePickerComponent = (props) => {

    const [type, setType] = useState("single");

    const renderMultiDatePicker = () => {
        if (type === 'multi') {
            return(
                <Form.Control
                    type="date"
                    name={`${props.field.name}-mr-2`}
                    onChange={props.formik.handleChange}
                    value={props.formik.values[`${props.field.name}-mr-2`]}
                    className="inputClear"
                    style={{fontSize: "13px", height:"40px", color: "#000000"}}
                />
            );
        }
    };

    const handleWhenChangeOption = () => {
        if (document.getElementById(props.field.name + "-mr-filter-type").value === "DATE_BETWEEN"){
            setType("multi");
        }else {
            setType("single")
        }
    }

    return(
        <Form.Group as={Col} md="4">
            <Form.Label>{props.field.name}</Form.Label>
            <InputGroup >
                <Form.Control
                    type="date"
                    name={props.field.name}
                    onChange={props.formik.handleChange}
                    value={props.formik.values[`${props.field.name}`]}
                    className="inputClear"
                    style={{fontSize: "13px", height:"40px", color: "#000000"}}
                />
                {renderMultiDatePicker()}
                <Form.Control
                    onChange={() => handleWhenChangeOption()}
                    value={props.formik.values[`${props.field.name}-mr-filter-type`]}
                    as="select"
                    id={props.field.name + "-mr-filter-type"}
                    name={props.field.name + "-mr-filter-type"}
                    style={{height: "40px", width: "110px", maxWidth: "110px"}}>
                    <option selected= "selected" key={props.field.name + "-filter-type-like"} onClick={() => setType("single")} value={'DATE_EQUALS'}>Equals</option>
                    <option key={props.field.name + "-filter-type-before"} onClick={() => setType("single")} value={'DATE_BEFORE'}>Before</option>
                    <option key={props.field.name + "-filter-type-after"} onClick={() => setType("single")} value={'DATE_AFTER'}>After</option>
                    <option key={props.field.name + "-filter-type-between"} onClick={() => setType("multi")} value={'DATE_BETWEEN'}>Between</option>
                </Form.Control>
            </InputGroup>
        </Form.Group>
    );

}

export default DatePickerComponent;
